import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { getTeam as getTeamFromMonolith, Team } from '~/monolith-api';
import { CommonRequestOptions } from '~/monolith-api/makeRequest';

export type { Team };

export type GetTeamErrorCode = 'teams.team_not_found';

const getTeamSchema = z.object({
   teamid: z.number(),
});

export async function getTeam(teamid: number, options: CommonRequestOptions) {
   return await getTeamFromMonolith(teamid, options);
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { teamid } = getTeamSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getTeam(teamid, {
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const getTeamFromClient = (teamid: number): ReturnType<typeof getTeam> => {
   return bff()
      .post('/teams/getTeam', {
         teamid,
      })
      .then(response => response.data);
};
